import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { CostCenterInputComponent } from '@modules/bcm/cost-centers/cost-center-input/cost-center-input.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [CostCenterInputComponent],
    exports: [CostCenterInputComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatAutocompleteModule,
        SharedModule,
        MatSelectModule,
        MatTooltipModule,
        TranslationModule,
    ]
})
export class CostCenterInputModule {
}
